import { useParams, Link } from "react-router-dom";
import { useMemo, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import MovieCard from "@/components/feature/MovieCard";
import ScrollToTop from "@/components/base/ScrollToTop";
import SchemaOrg from "@/components/base/SchemaOrg";
import { movies, categories } from "@/mocks/movies";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCat, setActiveCat] = useState(slug || "all");

  const catInfo = useMemo(
    () => categories.find((c) => c.slug === activeCat) || { name: "全部影片", slug: "all" },
    [activeCat]
  );

  const filtered = useMemo(() => {
    if (activeCat === "all") return movies;
    return movies.filter((m) => m.category === activeCat);
  }, [activeCat]);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="CollectionPage"
        data={{
          name: `${catInfo.name} - 八戒影院`,
          description: `八戒影院${catInfo.name}分类，提供海量高清免费${catInfo.name}在线观看，流畅播放不缓冲。`,
          url: `https://smwneuh.cn/category/${activeCat}`,
          isPartOf: { "@type": "WebSite", name: "八戒影院", url: "https://smwneuh.cn/" },
        }}
      />
      <Navbar />
      <main className="pt-20">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: catInfo.name },
          ]}
        />

        <section className="px-4 md:px-6 pb-10 md:pb-14">
          <div className="max-w-[1280px] mx-auto">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
              {catInfo.name}
            </h1>
            <p className="text-sm text-foreground-500 mb-6">
              共 {filtered.length} 部影片
            </p>

            <div className="flex items-center gap-1 mb-8 overflow-x-auto pb-1 flex-wrap">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCat(cat.slug)}
                  className={`flex items-center gap-1.5 px-4 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                    activeCat === cat.slug
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-600 hover:text-primary-500"
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-xs`}></i>
                  </div>
                  {cat.name}
                </button>
              ))}
            </div>

            {filtered.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                {filtered.map((movie) => (
                  <MovieCard
                    key={movie.id}
                    id={movie.id}
                    title={movie.title}
                    slug={movie.slug}
                    category={movie.category}
                    year={movie.year}
                    rating={movie.rating}
                    poster={movie.poster}
                    tags={movie.tags}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-movie-line text-4xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无影片</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}